// components/LeftPanel.js
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LEGAL_RESEARCH_REQUEST_STATUS } from "utils/constantValues";
import BroadcastCard from "./broadcastCard";
import ProposalDocument from "./proposalDocument";
import ResearchDraft from "./researchDraft";

function LeftPanel({
  request,
  activeTab,
  showBroadcast = false,
  onBroadcast,
  showForward = false,
  onForward,
  showAssignProsecutor = false,
  onAssignProsecutor,
  broadcastLoading = false,
}: {
  request: any;
  activeTab: string;
  showBroadcast?: boolean;
  onBroadcast?: (isPublished: boolean) => void;
  showForward?: boolean;
  onForward?: () => void;
  showAssignProsecutor?: boolean;
  onAssignProsecutor?: () => void;
  broadcastLoading?: boolean;
}) {
  const { t } = useTranslation();
  const [formState, setFormState] = useState({
    ...request,
    urgency_level: request?.urgency_level
      ? request?.urgency_level.charAt(0).toUpperCase() +
        request?.urgency_level.slice(1).toLowerCase()
      : "High",
  });

  return (
    <div className="flex flex-col flex-1 bg-gray-100 mr-4 rounded-lg">
      {showBroadcast &&
        formState?.status === LEGAL_RESEARCH_REQUEST_STATUS.completed.value && (
          <BroadcastCard
            onClick={() => onBroadcast && onBroadcast(!formState?.is_published)}
            isPublished={formState?.is_published || false}
            loading={broadcastLoading}
          />
        )}
      {showForward && (
        <div className="bg-white p-4 rounded-lg shadow-md mb-4 mx-4 mt-4">
          {/* Button commented out in original */}
        </div>
      )}
      {formState.assigned_prosecutor_name && (
        <div className="bg-white p-4 rounded-lg shadow-md mb-4 mx-4 mt-4">
          <p className="text-sm font-medium">
            {t("AssignedProsecutor")}: {formState.assigned_prosecutor_name}
          </p>
        </div>
      )}
      {activeTab === t("ProposalDocument") ? (
        <ProposalDocument filteredData={request} />
      ) : (
        (formState?.status ===
          LEGAL_RESEARCH_REQUEST_STATUS.research_underway.value ||
          formState?.status ===
          LEGAL_RESEARCH_REQUEST_STATUS.draft_submitted.value ||
          formState?.status ===
          LEGAL_RESEARCH_REQUEST_STATUS.draft_revision.value ||
          formState?.status ===
          LEGAL_RESEARCH_REQUEST_STATUS.draft_approved.value ||
          formState?.status ===
          LEGAL_RESEARCH_REQUEST_STATUS.completed.value ||
          formState?.documents?.find(
            (document: any) => document.document_type === "research_draft_file",
          )) && <ResearchDraft request={request} />
      )}
    </div>
  );
}

export default LeftPanel;